import { render, staticRenderFns } from "./folderManagement.vue?vue&type=template&id=232ca36c&scoped=true"
import script from "./folderManagement.vue?vue&type=script&lang=js"
export * from "./folderManagement.vue?vue&type=script&lang=js"
import style0 from "./folderManagement.vue?vue&type=style&index=0&id=232ca36c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232ca36c",
  null
  
)

export default component.exports